module.exports = __webpack_public_path__ + "img/logo_el_farolito.ee6a2b7f.webp";